import $ from 'jquery';
import plugin from '@core/plugins/lib';
import MegaLink from './mega-link';

const ELEMENT_SELECTOR = '[data-mega-link]';
const PLUGIN_NAME = 'MegaLink';

plugin(PLUGIN_NAME, MegaLink);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__mega-link/plugin--bundled.js